import React from 'react';

interface VenereWeightProps {
  size?: number;
  className?: string;
  color?: string;
  onClick?: () => void;
}

export const VenereWeight: React.FC<VenereWeightProps> = ({
  size = 24,
  className = '',
  color = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 2000"
      fill={color}
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path d="M1627.27,1469.15v105.84c0,28.87-23.4,52.27-52.27,52.27H425.01c-28.87,0-52.27-23.4-52.27-52.27V425.01c0-28.87,23.4-52.27,52.27-52.27h1149.99c28.87,0,52.27,23.4,52.27,52.27v834.33c0,28.87,23.4,52.27,52.27,52.27h0c28.87,0,52.27-23.4,52.27-52.27V425.01c0-86.61-70.21-156.82-156.82-156.82H425c-86.61,0-156.81,70.21-156.81,156.81v1149.99c0,86.61,70.21,156.82,156.82,156.82h1149.99c86.61,0,156.82-70.21,156.82-156.82v-105.84c0-28.87-23.4-52.27-52.27-52.27h0c-28.87,0-52.27,23.4-52.27,52.27Z"/>
      <path d="M1000,477.28h0c-259.4,0-470.45,211.05-470.45,470.45,0,28.88,23.39,52.27,52.27,52.27h836.36c.39-.07.72-.07,1.05,0,28.88,0,52.27-23.39,52.27-52.27,0-3.79-.39-7.51-1.18-11.11-5.95-254.3-214.64-459.34-470.32-459.34ZM1097.68,895.46l50.38-75.53c16.01-24.04,9.54-56.45-14.5-72.46-24.05-16.01-56.45-9.54-72.46,14.51l-89.06,133.49h-334.21c25.42-177.07,178.18-313.63,362.18-313.63s336.77,136.56,362.18,313.63h-264.49Z"/>
    </svg>
  );
};

export default VenereWeight; 